module.exports = __webpack_public_path__ + "img/me_6a5a3.png";